import type { Product, ProductBillOfMaterial } from '@ztechapps/common.contract'
import { convertFromBaseUnit, quickClone } from '@ztechapps/common.utils'

export type BomInventory = {
  qtyOnHand: number
  baseQtyOnHand: number
  requiredToBuild: boolean
  product: Product
}

export function getBomInventory(product: Product): Map<string, BomInventory> {
  //we don't want to mutate the product so we cloned it
  const productClone = quickClone(product)

  const inventoryMap = new Map<string, BomInventory>()

  function traverse(bom: ProductBillOfMaterial) {
    const p = bom.product as Product
    //we need to set only when the productId is not yet on the map or there is no _id itself
    if (inventoryMap.has(p._id)) {
      return
    }

    // Add or update the quantityOnHand for this product
    if (p._id) {
      p.hasSubComponents = p.billOfMaterials?.length > 0

      //and we need to exclude the main product
      if (p._id !== productClone._id) {
        const baseQtyOnHand = p?.inventory?.quantityOnHand ?? 0
        inventoryMap.set(p._id, {
          product: p,
          requiredToBuild: bom.requiredToBuild,
          qtyOnHand: convertFromBaseUnit(
            baseQtyOnHand,
            p?.workOrderConversionFactor ?? 1,
            p?.unitOfMeasurePrecision ?? 0
          ),
          baseQtyOnHand,
        })
      }
    }

    // Traverse its BOM if any
    if (p.billOfMaterials) {
      for (const bom of p.billOfMaterials) {
        traverse(bom)
      }
    }
  }

  traverse({ product: productClone } as ProductBillOfMaterial)

  return inventoryMap
}
